<script setup lang="ts">
import type { PinInputProps } from '.';
import type { PinInputRootEmits } from 'reka-ui';

import { cn } from '@/utils';
import { PinInputRoot, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

const props = withDefaults(defineProps<PinInputProps>(), {
	modelValue: () => []
});
const emits = defineEmits<PinInputRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<PinInputRoot
		v-bind="forwarded"
		:class="cn('flex items-center gap-2', props.class)"
	>
		<slot></slot>
	</PinInputRoot>
</template>
